import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../../../helpers/value'
import { convertDataApi } from '../../../helper'
import { getNonLifeInsOperationalEfficiencyThunk } from './thunk'

const initialState = {
  dataViewByTrend: [],
  dataViewByEachYear: {},
  idTable: [],
  byIdTable: {},
  years: [],
  loading: true,
  indicator: [],
  indicatorById: {},
}

const slice = createSlice({
  name: 'companyAnalysis/financialAnalysis/nonLifeIns/operationalEfficiency',
  initialState: initialState,
  reducers: {
    resetStoreNonLifeInsOperationalEfficiency: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      getNonLifeInsOperationalEfficiencyThunk.pending,
      (state) => {
        state.loading = true
      },
    )
    builder.addCase(
      getNonLifeInsOperationalEfficiencyThunk.fulfilled,
      (state, action) => {
        const data = convertDataApi(action.payload)

        Object.keys(data).forEach((key) => {
          state[key] = data[key]
        })

        state.loading = false
      },
    )
    builder.addCase(
      getNonLifeInsOperationalEfficiencyThunk.rejected,
      (state) => {
        state.loading = false
      },
    )
  },
})

export const { resetStoreNonLifeInsOperationalEfficiency } = slice.actions

export const selectLoading = (state) => state[slice.name].loading

export const selectIdTable = (state) => state[slice.name].idTable

export const selectByIdTable = (state) => state[slice.name].byIdTable

export const selectCell = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].byIdTable[id], attr)

export const selectYears = (state) => state[slice.name].years

export const selectDataViewByTrend = (state) =>
  state[slice.name].dataViewByTrend

export const selectDataViewByEachYear = (year) => (state) =>
  state[slice.name].dataViewByEachYear[year] || []

export const selectIndicator = (state) => state[slice.name].indicator

export const selectIndicatorById = (state) => state[slice.name].indicatorById

register(slice.name, slice.reducer)
